// @martyrs/src/modules/auth/locales/ru.js
export default {
  auth: {
    popup: {
      title: "Добро пожаловать",
      subtitle: "Войдите или создайте аккаунт для продолжения.",
      signUp: "Регистрация",
      haveAccount: "Уже есть аккаунт?",
      signIn: "Войти"
    },
    signIn: {
      title: "Приветствуем вас,",
      subtitle: "Войдите для продолжения",
      signup: "Нет аккаунта?",
      phone: "Телефон",
      email: "Email",
      phonePlaceholder: "Введите ваш телефон",
      emailPlaceholder: "Введите ваш email",
      haveAccount: "Нет аккаунта? Зарегистрироваться",
      passwordPlaceholder: "Введите ваш пароль",
      forgotPassword: "Забыли пароль?",
      signin: "Войти",
      signin_apple: "Войти через Apple",
      soon: "СКОРО"
    },
    signUp: {
      title: "Новая учетная запись",
      description: "Выберите удобный способ регистрации через телефон или email:",
      phone: "Телефон",
      email: "Email",
      phonePlaceholder: "Введите ваш телефон",
      emailPlaceholder: "Введите ваш email",
      emailNotice: "Мы отправим вам электронное письмо с кодом подтверждения, который вы должны будете ввести в следующем шаге.",
      smsNotice: "Мы вышлем вам SMS с кодом подтверждения, который вы должны будете ввести в следующем шаге.",
      sendCode: "Отправить код",
      haveAccount: "У вас уже есть аккаунт?",
      agreement: "Регистрируясь, вы соглашаетесь с <a href='/legal/eula' target='_blank'>Пользовательским соглашением (EULA)</a>"
    },
    enterCode: {
      verifyNumberTitle: "Подтвердите номер",
      verifyEmailTitle: "Подтвердите email",
      instructions: "Мы отправили код на ваш номер телефона. Введите его в поле ниже:",
      instructionsEmail: "Мы отправили код на ваш email. Введите его в поле ниже:",
      verifyChangeTitle: "Подтвердите изменение",
      current: "Текущий",
      new: "Новый",
      confirm: "Подтвердить",
      resendCode: "Отправить код еще раз",
      secondsResend: "секунд до возможности отправить код еще раз."
    },
    resetPassword: {
      forgotPasswordTitle: "Забыли пароль?",
      instructions: "Чтобы сбросить пароль, укажите телефон или email, использованные при регистрации.",
      smsInfo: "Мы вышлем вам SMS с кодом подтверждения для сброса пароля, который вы должны будете ввести в следующем шаге.",
      emailInfo: "Мы отправим вам электронное письмо с кодом подтверждения  для сброса пароля, который вы должны будете ввести в следующем шаге.",
      phone: "Телефон",
      email: "Email",
      phonePlaceholder: "Введите ваш телефон",
      emailPlaceholder: "Введите ваш email",
      sendCode: "Отправить код"
    },
    enterPassword: {
      almostDone: "Почти все!",
      newPasswordPrompt: "Пожалуйста, укажите новый пароль.",
      registrationPasswordPrompt: "Пожалуйста, укажите пароль, на этом регистрация будет закончена.",
      passwordPlaceholder: "Пароль",
      repeatPasswordPlaceholder: "Повторите пароль",
      changePasswordBtn: "Поменять пароль",
      registerBtn: "Зарегистрироваться"
    },
    features: [
      {
        title: "Всё в одном месте",
        description: "Управляйте своим аккаунтом, данными и настройками из единого интерфейса."
      },
      {
        title: "Безопасность по умолчанию",
        description: "Вход по коду и надёжное хранение данных — ваш аккаунт под защитой."
      },
      {
        title: "Быстрый старт",
        description: "Регистрация занимает минуту — и вы сразу приступаете к работе."
      },
      {
        title: "Поддержка рядом",
        description: "Нужна помощь? Мы на связи и готовы ответить на ваши вопросы."
      }
    ]
  }
};